import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-inspections-due',
    templateUrl: './inspections-due.component.html',
    styleUrls: ['./inspections-due.component.scss'],
    standalone: false
})
export class InspectionsDueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
